import { xlBreakpoint } from "../App";

const carouselSidebars = [
  "playlist",
  "share",
  "livePosition",
  "settings",
] as const;

//at most one sidebar is open at a time
export type CarouselSidebar = (typeof carouselSidebars)[number];

//the value comes from the url, so anything unknown counts as "no sidebar open"
export function toCarouselSidebar(value: unknown): CarouselSidebar | undefined {
  return carouselSidebars.find((sidebar) => sidebar === value);
}

/** from xl on the sidebar is shown beside the slides, below it takes the whole screen (see SongsheetCarousel.css) */
export function isSidebarBesideSlides() {
  return window.matchMedia(`(min-width: ${xlBreakpoint})`).matches;
}
